module.exports = __webpack_public_path__ + "img/eyes-looking-into-camera.fbee405e.png";